module.exports = __webpack_public_path__ + "static/img/10_ワクチン接種.1102f46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10_ワクチン接種.png
// module id = rF3P
// module chunks = 0